import { Navigate, Route } from "react-router";
import Profile from "../Profile";
import { More } from "./components/More";
import { ProfileExtra } from "./components/ProfileExtra";
import { ProfilePersonal } from "./components/ProfilePersonal";
import { ProfileTac } from "./components/ProfileTac";

export const getProfileScene = () => (
  <Route path="profile" element={<Profile />}>
    <Route path="personal" element={<ProfilePersonal />} />

    <Route path="extra" element={<ProfileExtra />} />

    <Route path="tac" element={<ProfileTac />} />

    <Route path="more" element={<More />} />

    <Route index element={<Navigate to="personal" replace={true} />} />
  </Route>
);
